<template>
  <div class="btn btn-outline-secondary btn-sm" type="button" @click="toggleWon()">
    <span v-if="waitingForResponse" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    <img v-else-if="nominationWon" class="checkbox-image checkbox-won" :src="winIcon" alt="won" width="16" height="16">
    <img v-else class="checkbox-image" :src="nomIcon" alt="nom" width="16" height="16">
  </div>
</template>


<script>
import axios from "axios";
import analytics from "@/analytics";

export default {
  name: "NominationWonCheckbox",
  props: ['nomination'],
  emits: ['nomination-updated'],
  data() {
    return {
      nominationWon: false,
      waitingForResponse: false
    }
  },
  computed: {
    nomIcon() {
      return `${this.$imagePathBase}nom_icon.svg`
    },
    winIcon() {
      return `${this.$imagePathBase}win_icon-gold.svg`
    }
  },
  created() {
    this.nominationWon = this.nomination.won;
  },
  methods: {

    async toggleWon() {

      if ( this.waitingForResponse ) {
        return;
      }

      this.waitingForResponse = true;

      const endpoint = this.nominationWon? 'clear-nomination-won' : 'set-nomination-won';
      axios.post(`/api/admin/${endpoint}`, {
        nomination_id: this.nomination._id
      })
          .then(response => {
            //console.log(response);
            const updatedNomination = response.data;
            this.$emit('nomination-updated', updatedNomination);
          })
          .catch((err) => {
            analytics.notifyBugsnagOfError(err);
          })
          .finally(() => {
            this.waitingForResponse = false;
          })
    }
  }
}
</script>


<style scoped>
.btn {

  //border-color: lightcoral;

  margin-right:5px;

  height: 20px !important;
  width: 20px !important;

  .checkbox-image {
    position: absolute;
    margin-top: -2.5px;
    margin-left: -8px;
    opacity: 50%;
    &.checkbox-won {
      opacity: 100%;
    }
  }
  .spinner-border {
    opacity: 30%;
    position: absolute;
    height: 12px !important;
    width: 12px !important;
    margin-top: -0.5px;
    margin-left: -6px;
  }
}

.btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
}
</style>